import { DatePicker } from 'antd';

import Input from 'components/Input';
import { FORMAT_TIME } from 'constants/index';
import { ENUM_ACTIVE_CHECKBOX } from 'constants/enum';
import { TEXT_CREATE_SURVEY } from 'constants/string/texts';
import dayjs from 'dayjs';

const DateOption = (props) => {
  const { data, isPreview } = props;

  return (
    <div>
      {isPreview ? (
        <Input
          value=""
          readOnly
          disabled={true}
          placeholder={TEXT_CREATE_SURVEY.PLACEHOLDER_DATE}
          list={[{ text: TEXT_CREATE_SURVEY.PLACEHOLDER_DATE, value: '' }]}
          type="dropdown"
          className="w-full"
          classNameInput="rounded-lg w-full text-secondary-354"
        />
      ) : (
        <DatePicker
          value={data?.answer ? dayjs(data.answer) : ''}
          disabled={true}
          className={`h-10 ${data?.answer ? 'datepicker-text-black-102' : ''} text-gray-102/65 datepicker-disabled border-0 !bg-transparent !border-b !border-dashed !border-gray-102/65 !rounded-none !p-0 hover:bg-transparent !hover:outline-none !shadow-none ${isPreview ? 'w-1/2' : '!w-50'}`}
          separator={null}
          format={(data?.active_checkbox || [])?.indexOf(ENUM_ACTIVE_CHECKBOX.INCLUDE_YEAR) === -1 ? FORMAT_TIME.MONTH_DAY : FORMAT_TIME.DATE}
          placeholder={
            (data?.active_checkbox || [])?.indexOf(ENUM_ACTIVE_CHECKBOX.INCLUDE_YEAR) === -1
              ? TEXT_CREATE_SURVEY.PLACEHOLDER_DATE_FORMAT
              : TEXT_CREATE_SURVEY.PLACEHOLDER_DATE_YEAR_FORMAT
          }
        />
      )}
    </div>
  );
};

export default DateOption;
